import {createUIDefinition} from '../default-task-definition';
import * as taskName from './task-name';
import * as processUI from '../../process-ui';

export default createUIDefinition({
    taskName: taskName.CONFIRM_REFUND,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.PARTIAL_INVOICE_CORRECTION_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.PAYMENT_LIST_WIDGET,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/partial-refund/confirm-refund.js